<template>
  <v-container>
    <v-card>
      <v-card-title class="title white--text">{{$t('ratingConfig.title') | capitalize}}</v-card-title>
      <v-card-text class="content">
        <h4>{{$t('ratingConfig.autoCloseRatingSession') | capitalize}}</h4>
        <v-form ref="form">
          <div class="d-flex align-center">
            <v-switch color="primary" hide-details class="my-0 px-0" v-model="cfg.is_enabled">
              <template v-slot:label>
                <strong v-if="cfg.is_enabled" class="success--text">{{ $t('on')|capitalize }}</strong>
                <strong v-else class="error--text">{{ $t('off')|capitalize }}</strong>
              </template>
            </v-switch>
          </div>
          <div class="d-flex align-center" style="gap: 10px">
            <div class="input">
              <label>{{$t('closeRatingSessionDuration')|capitalize}}</label>
              <v-text-field type="number" outline solo dense flat style="font-size: 14px" min="1" :rules="[formRules.ruleMin(1)]" v-model="cfg.delay_time"></v-text-field>
            </div>
            <div class="input">
              <label>{{$t('action')|capitalize}}</label>
              <v-select outline solo dense flat v-model="cfg.action" :items="actions" style="font-size: 14px"></v-select>
            </div>
          </div>
          <div class="input" v-if="cfg.action === 1">
            <label>{{$t('notifyMessage')}}</label>
            <v-textarea
                v-model="cfg.message"
                outline
                ref="description"
                solo
                auto-grow
                flat
                rows="3"
                hide-details
                style="font-size: 14px"
            ></v-textarea>
          </div>
        </v-form>
        <hr style="border: 1px solid #d3d3d3;">
        <h4>{{$t('ratingConfig.autoSendRating') | capitalize}}</h4>
        <v-switch color="primary" hide-details class="my-0 px-0" v-model="cfg.is_auto_send">
          <template v-slot:label>
            <strong v-if="cfg.is_auto_send" class="success--text">{{ $t('on')|capitalize }}</strong>
            <strong v-else class="error--text">{{ $t('off')|capitalize }}</strong>
          </template>
        </v-switch>
        <div class="align-self-end">
          <v-btn class="ma-0 text-none" color="primary" depressed type="submit" @click="onSubmit">{{ $t('save')|capitalize }}</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {sync} from "vuex-pathify";
import {mapActions} from "vuex";
import FormMixin from "@/mixins/FormMixin";

export default {
  name: "RatingConfig",
  mixins: [FormMixin],
  props: {
    botCode: String,
  },
  data() {
    return {
      actions: [
        {
          text: this.$t('doNothing'),
          value: 0
        },
        {
          text: this.$t("sendMessage"),
          value: 1
        }
      ]
    }
  },
  mounted() {
    this.fetchRatingCfg()
  },
  computed: {
    cfg: sync('rating/ratingCfg')
  },
  methods: {
    ...mapActions('rating', ['fetchRatingCfg', 'updateRatingCfg']),
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.updateRatingCfg()
      }
    },
  },
  watch: {
    botCode() {
      this.fetchRatingCfg()
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  font-size: 18px !important;
}
.content {
  display: flex;
  flex-direction: column;
  gap: 20px
}
::v-deep .v-text-field--outline>.v-input__control>.v-input__slot {
  min-height: 34px !important;
}
::v-deep.v-text-field--outline input {
  margin: 0 !important;
}
::v-deep.theme--light.v-text-field--outline>.v-input__control>.v-input__slot {
  border: 1px solid #D9D9D9 !important;
  border-radius: 5px;
}
.input {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.input:focus {
  outline: none !important;
}
</style>